import React, { useState, useEffect } from "react";

const filterOptions = ["Rated Excellent(9+)", "Free Cancellation", "5 Star","4 Star","3 Star"];

export default function MobileFilters({ filters, onFilterChange }) {
  const [selected, setSelected] = useState(filters.popular || []);

  const toggleFilter = (value) => {
    const updated = selected.includes(value)
      ? selected.filter((item) => item !== value)
      : [...selected, value];
    setSelected(updated);
  };

  useEffect(() => {
    console.log("Calling onFilterChange", { selected });
    if (typeof onFilterChange === "function") {
      onFilterChange({
        ...filters,
        popular: selected,
      });
    }
  }, [selected]);

  return (
    <div className="lg:hidden px-4 py-2 flex flex-row  w-full overflow-x-auto gap-3">
      {filterOptions.map((filter, idx) => (
        <button
          key={idx}
          onClick={() => toggleFilter(filter)}
          className={`px-4 py-2 rounded-full border text-sm shadow-sm ${
            selected.includes(filter)
              ? "bg-blue-500 text-white border-blue-500"
              : "bg-white text-gray-700 border-gray-300"
          }`}
        >
          {filter}
        </button>
      ))}
    </div>
  );
}
